<template>
  <ul class="questions__list">
    <template
      v-for="(question, questionIndex) in questions"
      :key="questionIndex"
    >
      <li>
        <BaseAccordion class="ui-accordion-primary">
          <template #title>
            <span
              class="questions-item__title typography__title1"
              v-html="t(question.question)"
            />
          </template>

          <template #button="{ show }">
            <BaseIcon2
              :id="show ? 'icon-minus-circle' : 'icon-plus-circle'"
              class="accordion__item-icon"
              :color="show ? 'var(--grey-1)' : 'var(--grey-3)'"
              height="20"
              width="20"
            />
          </template>

          <template #content>
            <div
              class="typography__body1"
              v-html="t(question.answer)"
            />
          </template>
        </BaseAccordion>
      </li>

      <li v-if="questionIndex !== questions.length - 1">
        <BaseDivider class="ui-divider-primary" />
      </li>
    </template>
  </ul>
</template>
<script lang="ts" setup>
const { t } = useI18n();

const questions = computed(() => [
  {
    question: t("entities.rate.faq.q1"),
    answer: t("entities.rate.faq.a1"),
  },
  {
    question: t("entities.rate.faq.q2"),
    answer: t("entities.rate.faq.a2"),
  },
  {
    question: t("entities.rate.faq.q3"),
    answer: t("entities.rate.faq.a3"),
  },
  {
    question: t("entities.rate.faq.q4"),
    answer: t("entities.rate.faq.a4"),
  },
  {
    question: t("entities.rate.faq.q5"),
    answer: t("entities.rate.faq.a5"),
  },
  {
    question: t("entities.rate.faq.q6"),
    answer: t("entities.rate.faq.a6"),
  },
  {
    question: t("entities.rate.faq.q7"),
    answer: t("entities.rate.faq.a7"),
  },
  {
    question: t("entities.rate.faq.q8"),
    answer: t("entities.rate.faq.a8"),
  },
  {
    question: t("entities.rate.faq.q9"),
    answer: t("entities.rate.faq.a9"),
  },
  {
    question: t("entities.rate.faq.q10"),
    answer: t("entities.rate.faq.a10"),
  },
  {
    question: t("entities.rate.faq.q11"),
    answer: t("entities.rate.faq.a11"),
  },
  {
    question: t("entities.rate.faq.q12"),
    answer: t("entities.rate.faq.a12"),
  },
  {
    question: t("entities.rate.faq.q13"),
    answer: t("entities.rate.faq.a13"),
  },
  {
    question: t("entities.rate.faq.q14"),
    answer: t("entities.rate.faq.a14"),
  },
]);
</script>

<style scoped>
.questions__list {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
}

.questions-item__title {
  text-align: left;
}

:deep(.questions__list .c-accordion__button) {
  align-items: flex-start;
  column-gap: 16px;
}

.accordion__item-icon {
  flex-shrink: 0;
}

@media (--hover) {
  :deep(.questions__list .c-accordion__button:hover .accordion__item-icon) {
    color: var(--grey-1);
  }
}
</style>
